export default __webpack_public_path__ + "static/media/pnp_2_bg.78873bbe.jpg";